var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.846 8.44189V16.846H12.6728V13.2113C12.6728 12.8926 12.4145 12.6343 12.0959 12.6343H8.03805C7.71937 12.6343 7.46112 12.8926 7.46112 13.2113V16.846H4.30718V8.44189H3.15332V17.4229C3.15332 17.7416 3.41161 17.9999 3.73025 17.9999H8.03808C8.35676 17.9999 8.61502 17.7416 8.61502 17.4229V13.7882H11.5189V17.423C11.5189 17.7416 11.7772 17.9999 12.0959 17.9999H16.4229C16.7416 17.9999 16.9999 17.7416 16.9999 17.423V8.44189H15.846Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8368 9.98237L10.4711 2.15524C10.2509 1.94889 9.90861 1.94755 9.6865 2.15158L1.16702 9.97875C0.932409 10.1943 0.917012 10.5592 1.1326 10.7938C1.24626 10.9178 1.40163 10.9805 1.55761 10.9805C1.69702 10.9805 1.83704 10.9301 1.94781 10.8284L10.0734 3.36315L18.0485 10.8249C18.2816 11.0428 18.6462 11.0303 18.8639 10.7978C19.0814 10.5651 19.0695 10.2001 18.8368 9.98237Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.7c7317b1f827790de64f4dd13bd6f1f2.svg";
export { ForwardRef as ReactComponent };